export default class SetSameHeight {

    handleEqualHeightOnContentElements() {
        const _contents = document.querySelectorAll('.pillars-item');
        if (window.innerWidth > 767) {
            this.setEqualHeightOnContentElements(_contents);
        } else {
            _contents.forEach((content) => {
                content.children[2].style.height = 'initial';
            });
        }
    }

    setEqualHeightOnContentElements(contents) {
        if (contents) {
            let _textMaxHeight = 0;
            contents.forEach((content) => {
                _textMaxHeight = this.getElementMaxHeight(content.children[2], _textMaxHeight);
            });

            contents.forEach((content) => {
                content.children[2].style.height = _textMaxHeight + 'px';
            });
        }
    }

    getElementMaxHeight(el, elMaxHeight) {
        if (el.clientHeight > elMaxHeight) {
            elMaxHeight = el.clientHeight;
        }
        return elMaxHeight;
    }

    init() {
        this.handleEqualHeightOnContentElements();
    }

}
